import { render, staticRenderFns } from "./LocacaoNovoEnderecoPage.vue?vue&type=template&id=0d24aa44&"
import script from "./LocacaoNovoEnderecoPage.vue?vue&type=script&lang=js&"
export * from "./LocacaoNovoEnderecoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports